import { Box, IconButton, Input } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useInputEvent } from "hooks";
import { useEffect, useState } from "react";
import { Clear, Done } from "@mui/icons-material";
import { convertString2JSON, deepCloneJsonObject, StorageUtil } from "utils";
import { isGroupOrChannelType } from "utils/view.utils";
import { SystemConstant } from "const";
import { saveMessageInQueue, useConversationContext } from "../ConversationContext";
import { replaceId2Name, replaceName2Id } from "utils/message.utils";
import FullEmojiLayout from "../MessengerChatInput/FullEmojiLayout";

const EditMessage = ({ message, onSubmit, onCloseEdit }) => {
  const classes = useStyles();
  const { inputRef, inputValue, insertContentInput, updateContentInput } = useInputEvent();
  const prefixKey = StorageUtil.getCurrentPrefixKey();
  const { groupDetail } = useConversationContext();

  const [defaultContent, setDefaultContent] = useState();
  const [modifiedMessage, setModifiedMessage] = useState();

  const handleChangeContent = event => updateContentInput(event.target.value);

  const handleUpdateContent = value => insertContentInput(value);

  const handleEditMessage = async () => {
    const content = inputValue.trim();

    if (content !== defaultContent) {
      const mentionList = deepCloneJsonObject(groupDetail.groupMembers);
      if (isGroupOrChannelType(groupDetail.groupType)) mentionList.push(SystemConstant.MENTION_ALL);

      let editContent;
      if (message.sendType === SystemConstant.SEND_TYPE.quote) {
        editContent = JSON.stringify({
          content_message: replaceName2Id(content, mentionList),
          quote_id: message.quoteId,
        });
      } else {
        editContent = replaceName2Id(content, mentionList);
      }

      await saveMessageInQueue({
        prefixKey,
        groupId: message.groupId,
        threadId: message.threadId,
        content: editContent,
        parentId: message.sourceId,
        mentionIds: message.mentions,
        sendType: message.sendType,
        options: convertString2JSON(message.options, {}),
      });

      setDefaultContent(content);
      setModifiedMessage(Date.now());

      if (onSubmit) onSubmit(content);
    }
    onCloseEdit();
  };

  useEffect(() => {
    if (modifiedMessage && modifiedMessage > message.modified) return;

    let isMounted = true;

    replaceId2Name(message.content, groupDetail.groupMembers, false).then(displayContent => {
      if (isMounted) {
        setDefaultContent(displayContent);
        updateContentInput(displayContent);
      }
    });

    return () => {
      isMounted = false;
    };
  }, [message]);

  return (
    <Box className={classes.editMessageRoot}>
      <Input
        classes={{
          root: classes.editMessageInputRoot,
          input: classes.editMessageInput,
        }}
        inputRef={inputRef}
        onChange={handleChangeContent}
        disableUnderline
        multiline
      />

      <Box className={classes.editActionBox}>
        <FullEmojiLayout onSelect={handleUpdateContent} />
        <Box>
          <IconButton onClick={onCloseEdit}>
            <Clear />
          </IconButton>
          <IconButton color="primary" onClick={handleEditMessage} disabled={inputValue === defaultContent}>
            <Done />
          </IconButton>
        </Box>
      </Box>
    </Box>
  );
};

export default EditMessage;

const useStyles = makeStyles({
  editMessageRoot: {
    backgroundColor: "#F3F3F5",
  },

  editMessageInputRoot: {
    width: "100%",
    padding: "16px 30px",
  },

  editMessageInput: {
    width: 520,
    maxWidth: "100%",
  },

  editActionBox: {
    display: "flex",
    justifyContent: "space-between",
    padding: "8px 16px",
    paddingTop: 0,
  },
});
